module.exports = __webpack_public_path__ + "static/media/h1.2db84080.png";